var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{attrs:{"app":""}},[_c('v-app-bar-nav-icon',{on:{"click":function($event){return _vm.$emit('toggleSidebar')}}}),_c('SearchBar',{staticClass:"mr-3"}),_c('v-spacer'),_c('UserMenu'),_c('LanguageMenu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }